<template>
  <footer class="main-footer" app>
    <div class="main-footer-search" @click="tabClicked(0)">
      <input
        id="main-footer-search-tab"
        type="radio"
        name="tab_switch"
        :checked="projectStore.selectedTab == 0"
      />
      <label for="main-footer-search-tab" name="tab-label">
        <img
          src="../assets/search.svg"
          alt="探す"
          class="main-footer-search-icon"
        />
      </label>
    </div>
    <div class="main-footer-favorite" @click="tabClicked(3)">
      <input
        id="main-footer-favorite-tab"
        type="radio"
        name="tab_switch"
        :checked="projectStore.selectedTab == 3"
      />
      <label for="main-footer-favorite-tab" name="tab-label">
        <img
          src="../assets/favorite.svg"
          alt="お気に入り"
          class="main-footer-favorite-icon"
        />
      </label>
    </div>
    <div class="main-footer-applied" @click="tabClicked(1)">
      <input
        id="main-footer-applied-tab"
        type="radio"
        name="tab_switch"
        :checked="projectStore.selectedTab == 1"
      />
      <label for="main-footer-applied-tab">
        <img
          src="../assets/applied.svg"
          alt="応募中"
          class="main-footer-applied-icon"
        />
        <span
          v-show="projectStore.notification.total > 0"
          :style="[
            projectStore.notification.total > 9
              ? 'width: 30px;'
              : 'width: 16px;',
          ]"
          >{{ projectStore.notification.total }}</span
        >
      </label>
    </div>
    <div class="main-footer-mypage" @click="tabClicked(2)">
      <input
        id="main-footer-mypage-tab"
        type="radio"
        name="tab_switch"
        :checked="projectStore.selectedTab == 2"
      />
      <label for="main-footer-mypage-tab">
        <img
          src="../assets/mypage.svg"
          alt="マイページ"
          class="main-footer-mypage-icon"
        />
      </label>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { ProjectStore } from "../store/ProjectStore";
const projectStore = ProjectStore();
// タブをクリックされたら表示内容を変更する（現状開いているタブの場合は何もしない）
const tabClicked = (id: number) => {
  // タイトル変更
  switch (id) {
    case 0:
      document.title = "募集中案件";
      projectStore.setSelectedTab(0);
      break;
    case 1:
      document.title = "応募案件";
      // projectStore.setSelectedStatus(1)
      projectStore.setSelectedTab(1);
      break;
    case 2:
      document.title = "マイページ";
      projectStore.setSelectedTab(2);
      break;
    case 3:
      document.title = "お気に入り";
      projectStore.setSelectedTab(3);
      break;
    default:
      document.title = "";
  }
};
</script>
<style scoped lang="scss">
@import "../assets/style/_variables.scss";
.main-footer {
  box-sizing: border-box;
  position: fixed;
  width: 100%;
  max-width: 480px;
  height: 75px;
  padding: 8px 35px;
  bottom: 0;
  background: #fdfdfd;
  border-top: 0.5px solid #b2b1b1;
  // z-index: 1;
  display: flex;
  justify-content: space-between;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  overflow: hidden;
}

input[name="tab_switch"] {
  display: none;
}
.main-footer-applied {
  position: relative;
  span {
    position: absolute;
    top: -5px;
    color: #ffffff;
    font-size: $FONT_SIZE_M;
    font-weight: bold;
    line-height: 20px;
    text-align: center;
    background: rgba(249, 208, 20, 1);
    border-radius: 10px;
    min-width: 20px;
    padding: 0 3px;
    box-sizing: border-box;
  }
}

#main-footer-search-tab:checked + label {
  .main-footer-search-icon {
    filter: brightness(0) saturate(100%) invert(28%) sepia(84%) saturate(5875%)
      hue-rotate(192deg) brightness(93%) contrast(94%);
  }
}

#main-footer-applied-tab:checked + label {
  .main-footer-applied-icon {
    filter: brightness(0) saturate(100%) invert(28%) sepia(84%) saturate(5875%)
      hue-rotate(192deg) brightness(93%) contrast(94%);
  }
}
#main-footer-favorite-tab:checked + label {
  .main-footer-favorite-icon {
    filter: brightness(0) saturate(100%) invert(28%) sepia(84%) saturate(5875%)
      hue-rotate(192deg) brightness(93%) contrast(94%);
  }
}

#main-footer-mypage-tab:checked + label {
  .main-footer-mypage-icon {
    filter: brightness(0) saturate(100%) invert(28%) sepia(84%) saturate(5875%)
      hue-rotate(192deg) brightness(93%) contrast(94%);
  }
}
</style>
